/*
 * Panel lateral de la política completa (ficha de producto, «Ver política completa»).
 * Mismo comportamiento que los paneles de las filas de entrega (enova-delivery.js): se cuelga del
 * body para quedar sobre la página, abre deslizando desde la derecha, cierra con la X, Escape o
 * tocando fuera, y en celular bloquea el scroll. Sin JS, el enlace abre la página de la política.
 */
(() => {
  if (window.enovaPolicyDrawerReady) return;
  window.enovaPolicyDrawerReady = true;

  const drawers = new Map();

  function setup(drawer) {
    if (drawers.has(drawer.id)) return drawers.get(drawer.id);
    const state = {
      drawer,
      wrapper: drawer.querySelector('.m-drawer__wrapper'),
      content: drawer.querySelector('.m-drawer__content'),
      trigger: null,
    };
    // La sección del producto queda bajo el header fijo: colgado del body se pinta encima.
    document.body.appendChild(drawer);
    drawer.querySelector('[data-enova-policy-close]')?.addEventListener('click', (event) => {
      event.preventDefault();
      close(state);
    });
    state.wrapper?.addEventListener('click', (event) => {
      if (event.target === state.wrapper) close(state);
    });
    drawers.set(drawer.id, state);
    return state;
  }

  function isOpen(state) {
    return state.wrapper && !state.wrapper.classList.contains('m:hidden');
  }

  function open(state, trigger) {
    state.trigger = trigger;
    if (window.innerWidth < 770) {
      document.documentElement.classList.add('prevent-scroll');
      state.wrapper.classList.add('mobile');
    }
    state.wrapper.classList.remove('m:hidden');
    const body = state.drawer.querySelector('.m-drawer__body');
    if (body) body.scrollTop = 0;
    requestAnimationFrame(() => {
      state.wrapper.style.setProperty('--m-bg-opacity', '0.5');
      state.content.style.setProperty('--m-translate-x', '0');
      state.content.focus();
    });
  }

  function close(state) {
    if (!isOpen(state)) return;
    state.wrapper.style.setProperty('--m-bg-opacity', '0');
    state.content.style.setProperty('--m-translate-x', '100%');
    setTimeout(() => {
      state.wrapper.classList.add('m:hidden');
      state.wrapper.classList.remove('mobile');
      document.documentElement.classList.remove('prevent-scroll');
      if (state.trigger && document.contains(state.trigger)) state.trigger.focus({ preventScroll: true });
    }, 300);
  }

  function init() {
    document.querySelectorAll('[data-enova-policy-drawer]').forEach(setup);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-enova-policy-open]');
    if (!trigger) return;
    const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!drawer) return;
    event.preventDefault();
    open(setup(drawer), trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    drawers.forEach((state) => close(state));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
